import { connect } from 'react-redux';

import get from 'lodash/get';
import { getFormInitialValues, getFormValues } from 'redux-form';

import i18n from 'shared/lib/i18n';

import AdminUserFormComponent from './AdminUserFormComponent';

import { ADMIN_CREATE_REQUESTED, NOTIFY_WARNING } from '../../actionConstants';
import { getBuildingsForFilter } from '../Building/actionCreators';
import { getPmcList } from '../PMC/actionCreators';
import { addRole, createStaff } from '../Staff/actionCreators';
import { uploadImage } from '../Visitor/actionCreators';

import { filterBuildings } from '../Exports/utils';
import { getRoleIdByName } from '../Person/utils';

import { roleNames } from '../Person/constants';

import apiClient from '../../apiClient';
import { history } from '../../store';

const form = 'Person';

const mapStateToProps = (state) => {
  const { pmcs, buildings, selectExisting } = state;

  const formValues = getFormValues(form)(state) || {};
  const formInitialValues = getFormInitialValues(form)(state) || {};
  const { primary: isMasterPM, isService, pmcs: selectedPmcs } = formValues;

  const hasSelectedPmcs = selectedPmcs?.length > 0;
  const filteredBuildings = filterBuildings(
    Object.values(buildings),
    selectedPmcs,
  );

  const initialValues = {
    isService: false,
    primary: false,
  };

  return {
    pmcs: Object.values(pmcs),
    buildings: filteredBuildings,
    formValues,
    formInitialValues,
    selectExisting,
    isMasterPM,
    isService,
    hasSelectedPmcs,
    initialValues,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onLoad: () => {
    getPmcList(dispatch);
    getBuildingsForFilter(dispatch, { withReset: true });
  },
  onSubmit: (rawData) => {
    // TODO: currently we cannot update admin users, once the endpoint is there
    // we can use this code
    const { images, ...data } = rawData;
    const uploadPersonImage = (res) => {
      const personId = get(res, 'data.id');
      const url = `persons/${personId}/photo/`;
      return uploadImage(dispatch, images, url);
    };

    // if there is no PMC we create a superadmin
    const {
      firstName,
      lastName,
      phoneNumber,
      email,
      isService,
      pmcs,
      buildings,
      primary,
    } = data;
    const formattedData = {
      firstName,
      lastName,
      phoneNumber,
      email,
    };
    if (isService) {
      return dispatch({
        type: ADMIN_CREATE_REQUESTED,
        payload: apiClient.admin.create({ ...formattedData, isService }),
        successMessage: i18n.t('user.ccAgentCreated'),
        isForm: true,
        callback: async (res) => {
          if (res) {
            await uploadPersonImage(res);
            history.goBack();
          }
        },
      });
    }
    if (!pmcs?.length) {
      formattedData.pmc = 0;
      return dispatch({
        type: ADMIN_CREATE_REQUESTED,
        payload: apiClient.admin.create(formattedData),
        successMessage: i18n.t('user.adminCreated'),
        isForm: true,
        callback: async (res) => {
          if (res) {
            await uploadPersonImage(res);
            history.goBack();
          }
        },
      });
    }

    const propertyManagerRoleId = getRoleIdByName(roleNames.property_manager);
    let properties = [];
    if (primary) {
      properties = pmcs?.map((pmcId) => ({
        role: propertyManagerRoleId,
        property: pmcId,
        primary: true,
      }));
    } else if (!buildings?.length) {
      properties = pmcs?.map((pmcId) => ({
        role: propertyManagerRoleId,
        property: pmcId,
        primary: false,
      }));
    } else {
      properties = buildings?.map((buildingId) => ({
        role: propertyManagerRoleId,
        property: buildingId,
        primary: false,
      }));
    }
    formattedData.properties = properties;
    const successMessage = i18n.t('user.pmCreated');
    return createStaff(dispatch, formattedData, successMessage, images);
  },
  onSelectExisting: (person, formValues) => {
    if (!person.id) {
      return dispatch({
        type: NOTIFY_WARNING,
        message: i18n.t('errors.noPersonIdProvided'),
      });
    }
    const data = {
      person: person.id,
      properties: [
        {
          property: formValues?.pmc,
          role: getRoleIdByName(roleNames.property_manager),
        },
      ],
    };
    return addRole(dispatch, data, (res) => {
      if (res) {
        history.goBack();
      }
    });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdminUserFormComponent);
